<template>
  <div class="company">
    <b-container fluid class="mt-top text-left pwi90">
	    <b-carousel fluid
	      id="carousel"
	      v-model="slide"
	      :interval="4000"
	      controls
	      background="#fffff"
	      @sliding-start="onSlideStart"
	      @sliding-end="onSlideEnd"
	    >
	      <b-carousel-slide :img-src="(ww>768)?require(`@/assets/img/Unternehmen_Slider_Weltweit.jpg`):require(`@/assets/img/Slider_Unternehmen_Weltweit_Mobil.jpg`)" class="pvh-auto">
	        <div class="carosel-big-text-top text-left">{{$t('global')}}</div>
	        <div class="carosel-text-desription text-left">{{$t('globalText')}}</div>
	      </b-carousel-slide>
	      <b-carousel-slide :img-src="(ww>768)?require(`@/assets/img/Unternehmen_Slider_Leidenschaft.png`):require(`@/assets/img/Slider_Unternehmen_Leidenschaft_Mobil.png`)" class="pvh-auto">
	        <div class="carosel-big-text-top text-left">{{$t('passion')}}</div>
	        <div class="carosel-text-desription text-left">{{$t('passionText')}}</div>
	      </b-carousel-slide>
	      <b-carousel-slide :img-src="(ww>768)?require(`@/assets/img/Unternehmen_Slider_Qualität.png`):require(`@/assets/img/Slider_Unternehmen_Qualität_Mobil.png`)" class="pvh-auto">
	        <div class="carosel-big-text-top text-left">{{$t('quality')}}</div>
	        <div class="carosel-text-desription text-left">{{$t('qualityText')}}</div>
	      </b-carousel-slide>
<!-- 
	      <b-carousel-slide :key="key" v-for="(slide, key) in slides" :img-src="(ww>768)?slide.picture:slide.mobPic" class="pvh-auto">
	        <div class="carosel-big-text-top text-left">{{slide.topText}}</div>
	        <div class="carosel-text-desription text-left">{{slide.description}}</div>
	      </b-carousel-slide>
 -->
	    </b-carousel>
	</b-container>
    <div class="big-text mt-0">{{$t('company')}}</div>
  </div>
</template>
<script>
import myImg1 from '@/assets/img/Unternehmen_Slider_Weltweit.jpg'
import myImg2 from '@/assets/img/Unternehmen_Slider_Leidenschaft.png'
import myImg3 from '@/assets/img/Unternehmen_Slider_Qualität.png'

import myMobImg1 from '@/assets/img/Slider_Unternehmen_Weltweit_Mobil.jpg'
import myMobImg2 from '@/assets/img/Slider_Unternehmen_Leidenschaft_Mobil.png'
import myMobImg3 from '@/assets/img/Slider_Unternehmen_Qualität_Mobil.png'

export default {
  name: 'Company',
  data () {
    return {
      ww: 1980,
      slide: 0,
      sliding: false,
      slides: [
        {
          picture: myImg1,
          mobPic: myMobImg1,
          topText: this.$t('global'),
          description: this.$t('globalText')
        },
        {
          picture: myImg2,
          mobPic: myMobImg2,
          topText: this.$t('passion'),
          description: this.$t('passionText')
        },
        {
          picture: myImg3,
          mobPic: myMobImg3,
          topText: this.$t('quality'),
          description: this.$t('qualityText')
        }
      ]
    }
  },
  methods: {
    onSlideStart (slide) {
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.sliding = false
    },
    setWindowSize () {
      this.ww = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    }
  },
	created () {
		this.setWindowSize()
		window.addEventListener('resize', () => {
		this.setWindowSize()
		})
	}
}
</script>
<style>
.company .container-fluid {
	max-width: 1400px;
}
.company .carousel-control-prev, .company .carousel-control-next {
  width: auto !important;
}
.company .carousel {
	margin-top: -40px;
    text-shadow: none; /* 1px 1px 2px #333; */
 }  
.company .carousel-caption {
 	top: 0;
 	left: 0;
 	width: 100%;
 	height: 100%;
 	right: unset !important;
 	bottom: unset !important; 
 }  
.company .carosel-big-text-top {
  position:absolute;
  font-weight:100;
  font-family:"Gotham-Thin";
  font-size:100px;
  color:#777;
  text-shadow:none;
  left:75px;
  top: -20px;
}
.company .carosel-text-desription {
	position: absolute;
	width: 50%;
	height: auto;
	bottom: 50px;
	background-color: rgba(50,50,50,0.8);
/*	background-color: rgba(48,123,173,0.8); */
	padding: 20px;
	font-weight: 500;
	right: 50px;
	border-radius: 0 0 20px 0;
	font-size: 14px;
	text-shadow: none;
}
.company .carousel-control-prev {
    left: -50px !important;
}
.company .carousel-control-next {
    right: -50px !important;
}
.company .carousel-control-prev-icon {
    background-image: url("../assets/img/Arrow_Slider_Left.png") !important;
    background-size: 40px !important;
    width: 45px !important;
    height: 100px !important;
}
.company .carousel-control-next-icon {
    background-image: url("../assets/img/Arrow_Slider_Right.png") !important;
    background-size: 40px !important;
    width: 45px !important;
    height: 100px !important;
}
.pvh-auto {
	padding: 10vh 10vw;
}
.pwi90 {
	padding: 0 90px !important;
}
@media only screen and (max-width: 1200px) {
	.company .carosel-big-text-top {
	  font-size:80px;
	  left:75px;
	}
}
@media only screen and (max-width: 992px) {
	.company .carosel-big-text-top {
	  font-size:80px;
	  left:75px;
	}
	.pvh-auto {
		padding: 10vh 5vw;
	}
	.company .carosel-text-desription {
		font-size: 13px;
		bottom: 50px;
		right: -10px;
		width: 70%;
	}
}
@media only screen and (max-width: 768px) {
	.company .carousel {
	    margin-bottom: 50px;
	 }  
	.company .carosel-big-text-top {
	  font-size:60px;
	  top:30px;
	  left:0;
	}
	.pvh-auto {
		padding: 8vh 5vw;
	}
	.company .carosel-text-desription {
		padding: 10px;
		font-size: 12px;
		bottom: 0px;
		right: 10px;
		width: 70%;
	}
}
@media only screen and (max-width: 576px) {
	.company .carousel {
		width: 85%;
		margin-left: 9vw;
		margin-top: -60px;
	 }  
	.company .carousel-control-prev {
		display: none;
	}
	.company .carousel-control-next {
		display: none;
	}
	.company .carosel-big-text-top {
	  top:40px;
	  font-size:45px;
	  left:0;
	}
	.company .carosel-text-desription {
		font-size: 0.8em !important;
		right: -10px !important;
	}
	.pwi90 {
	    padding: 0 50px !important;
	}
}
@media only screen and (min-width: 576px) {
}
</style>
<style scoped>
</style>
<i18n>
  {
    "de": {
      "company": "Unternehmen",
      "global": "Weltweit",
      "globalText": "Wir haben unsere Finger auf der ganzen Welt im Spiel: Bei der Montage von hochwertigen Einrichtungen sind wir Ihre erste Wahl – und das weltweit. Zusammen mit unseren ca. 85 Mitarbeitern bemühen wir uns täglich aufs Neue, den hohen Anforderungen sich ständig verändernder Rahmenbedingungen gerecht zu werden und unsere Kunden erstklassig zu bedienen.",
      "passion": "Leidenschaft",
      "passionText": "Sorgfältig ausgewählte Montagetischler und Führungskräfte mit profunder handwerklicher Ausbildung, Fremdsprachkenntnissen und großer Leidenschaft für ihren Beruf, sind in Verbindung mit neuen Technologien ein Garant für qualitativ hochwertige, termingerechte Montagearbeiten.",
      "quality": "Qualität",
      "qualityText": "Qualität und Termintreue bedeuten für uns, unsere Kunden immer wieder mit unserer Dienstleistung zu begeistern. In fast 30 Jahren unternehmerischer Tätigkeit haben wir hunderte Projekte weltweit zur vollsten Zufriedenheit unserer Auftraggeber abgewickelt. Wir haben eine klare Mission: \"Unsere Kunden mit höchster Perfektion zu überzeugen.\" Dafür stehen wir von GERA!"
    },
    "en": {
      "company": "Company",
      "global": "Global",
      "globalText": "We provide our quality around the world, and we are your first choice worldwide to install first-class facilities. Along with our approximately 85 employees, we put forth effort every day to meet the high standards of constantly changing conditions and provide top quality service for our customers.",
      "passion": "Passion",
      "passionText": "We guarantee high-quality installation work done on time by our carefully selected carpenters and managers with expert technical training, knowledge of foreign languages and a great passion for their profession combined with the latest technology.",
      "quality": "Quality",
      "qualityText": "Quality and complying with deadlines mean that we enthuse our customers again and again with our service. After almost 30 years in business, we have completed hundreds of projects around the world to the complete satisfaction of our customers. We have a clear mission, which is: “Impressing our customers with the highest degree of perfection.” That is what we stand for at GERA!"
    }
  }
</i18n>
